import { Input } from "antd";
import React from "react";
import isEmpty from "lodash/isEmpty";
import FilterDropdownButtons from "./FilterDropdownButtons";

let searchRef = null;
export const getColumnSearchFilterProps = ({ tableParams = {}, column = {} }) => {
  const filterColumn = tableParams.filters?.find((item) => item.column === column.dataIndex);
  const filterValue = filterColumn?.value || null;

  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
      <div className="table-filter-dropdown search-filter-dropdown">
        <Input
          ref={(node) => {
            searchRef = node;
          }}
          value={isEmpty(selectedKeys) ? undefined : selectedKeys}
          onChange={(e) => setSelectedKeys(e.target.value)}
          onPressEnter={() => confirm()}
          allowClear
        />
        <FilterDropdownButtons confirm={confirm} />
      </div>
    ),
    filterIcon: () => <i className="ti-search" />,
    filterDropdownProps: {
      onOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchRef?.select(), 100);
        }
      }
    },
    filteredValue: filterValue
  };
};
